// Where this deploy lives. Dev: *.lifeable.dev.gfmhq.com on the lifeable box. Prod: *.lifeable.co.
const base = process.env.LIFEABLE_BASE_DOMAIN || "lifeable.dev.gfmhq.com";
export const hosts = {
  base,
  www: `https://${base}`,
  app: `https://app.${base}`,
  admin: `https://admin.${base}`,
};
export const brand = {
  name: "Lifeable",
  headline: "Finally, Life Organized.",
  sub: "Know what's going on. Stay in control.",
  ai: "AI helps organize, connect and make sense of everything in your life.",
  company: "Grandfield Media",
  legalName: "Grandfield Media Private Limited",
  companyUrl: "https://grandfieldmedia.com/",
  phone: "+91 92479 12080",
  mailFrom: process.env.MAIL_FROM || "Lifeable <hello@lifeable.co>",
  supportEmail: "hello@lifeable.co",
  playStore: "https://play.google.com/store/apps/details?id=com.grandfieldmedia.lifeable", // Android app live on Google Play (14 Oct 2026)
  discord: "https://discord.gg/67J5CMCBu", // community + live support (Buds, 4 Oct 2026)
  address: "No 93 Koundinya Nagar, Nr Prathibha High School, I.E. Nacharam, Uppal, Hyderabad, Telangana 500076, India",
  cin: "U85499TS2026PTC221225",
  gstin: "36AANCG3247P1ZY",
};
export const isProd = process.env.NODE_ENV === "production" && !!process.env.LIFEABLE_PROD;
export const cookieDomain = process.env.COOKIE_DOMAIN || `.${base}`;
